export default "__VITE_ASSET__f0c75b88__"